import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '长沙启佳网络科技有限公司'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/voice'
            },
            {
              path: '/software/photo',
              name: 'software',
              component: resolve => require(['@/view/Software_photo'], resolve),
              meta: {
                title: 'APP产品丨拍照翻译通'
              }
            },
            {
              path: '/software/voice',
              name: 'software',
              component: resolve => require(['@/view/Software_voice'], resolve),
              meta: {
                title: 'APP产品丨语音翻译通'
              }
            },
            {
              path: '/software/fangyan',
              name: 'software',
              component: resolve => require(['@/view/Software_fangyan'], resolve),
              meta: {
                title: 'APP产品丨方言翻译器'
              }
            },
            {
              path: '/software/zeus',
              name: 'software',
              component: resolve => require(['@/view/Software_zeus'], resolve),
              meta: {
                title: 'APP产品丨宙斯点击器'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js